<div>
  @if (!hideLabel) {
  <label class="field-label">
    {{ label }}
    @if (isRequired) {
      <span class="text-red-600" aria-hidden="true">*</span>
    }
  </label>
  }
  @if (otherInfo) {
  <span class="text-dc-navy! pb-4 flex" [innerHTML]="otherInfo"></span>
  } @if(type == 'big-text'){
  <textarea
    #inputElement
    [formControl]="control"
    [placeholder]="placeholder"
    [rows]="rows"
    [class]="inputClasses"
    [ngClass]="{ 'border-red-500': control.touched && control.invalid }"
    [attr.maxlength]="maxlength"
    (input)="onInputChange($event)"
  ></textarea>
  @if (maxlength) {
  <div class="mt-1 flex items-center justify-between text-sm text-dc-navy/70">
    <span>
      {{
        "CHARACTER_COUNTER_MESSAGE"
          | translate : { maxlength: maxlength }
      }}
    </span>
    <span class="font-medium text-dc-navy">{{ currentLength }}/{{ maxlength }}</span>
  </div>
  }
  } @else if(type == 'amount'){
  <div class="flex space-x-2 items-center">
    <!-- currency dropdown -->
    <ng-select
      #inputElement
      [formControl]="currencyControl"
      [items]="currencyList"
      [bindLabel]="'Value'"
      [bindValue]="'Value'"
      placeholder="{{ 'CURRENCY' | translate }}"
      [loading]="loading"
      (change)="selectionChange($event)"
      class="min-w-34"
    >
      <!-- option rows -->
      <ng-template ng-option-tmp let-item="item">
        <span>{{
          item.Value ? item.Value : item.Name ? item.Name : item.label
        }}</span>
      </ng-template>

      <!-- what shows when closed -->
      <ng-template ng-label-tmp let-item="item">
        {{ item.Value ? item.Value : item.Name ? item.Name : item.label }}
      </ng-template>

      <!-- loader inside dropdown -->
      <ng-template ng-loading-text>
        <div class="flex items-center gap-2">
          <i class="fa fa-spinner fa-spin text-gray-500"></i>
          <span>{{ "LOADING" | translate }}</span>
        </div>
      </ng-template>
    </ng-select>
    <!-- amount input cell -->
    <input
      #inputElement
      type="text"
      [formControl]="control"
      (input)="onAmountInput($event)"
      [class]="inputClasses"
      [ngClass]="{ 'border-red-500': control.touched && control.invalid }"
      [attr.maxlength]="maxlength"
      (blur)="onBlur($event)"
    />
  </div>
  } @else if(type == 'number') {
  <input
    #inputElement
    [type]="type"
    [formControl]="control"
    [placeholder]="placeholder"
    [class]="inputClasses"
    [ngClass]="{ 'border-red-500': control.touched && control.invalid }"
    [attr.maxlength]="maxlength"
    min="0"
    (input)="onInputChange($event)"
  />
  }@else {
  <div class="relative">
    <input
      #inputElement
      [type]="effectiveInputType"
      [formControl]="control"
      [placeholder]="placeholder"
      [class]="inputClasses"
      [ngClass]="{
        'border-red-500': control.touched && control.invalid,
        'pr-10': showPasswordToggleButton
      }"
      [attr.maxlength]="maxlength"
      (input)="onInputChange($event)"
      (blur)="onBlur($event)"
    />
    @if (showPasswordToggleButton) {
      <button
        type="button"
        class="absolute inset-y-0 right-0 px-3 text-dc-navy/80 hover:text-dc-navy"
        [attr.aria-label]="passwordVisible ? 'Hide password' : 'Show password'"
        (click)="togglePasswordVisibility()"
      >
        <i class="fa" [ngClass]="passwordVisible ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
      </button>
    }
  </div>
  }

  <div class="fields-error-container">
    @if (control.touched && control.invalid) {

      <!-- 1. Required first -->
      @if (control.hasError('required')) {
        {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
      }

      <!-- 2. Whitespace only -->
      @else if (control.hasError('whitespace')) {
        {{ "VALIDATION_MSG.WHITESPACE" | translate }}
      }

      <!-- 3. Safe text -->
      @else if (control.hasError('safeText')) {
        {{ "VALIDATION_MSG.SAFETEXT" | translate }}
      }
      @else if (control.hasError('customSafeText')) {
        {{ "VALIDATION_MSG.CUSTOM_SAFETEXT" | translate }}
      }

      <!-- 4. Email -->
      @else if (control.hasError('email')) {
        {{ "VALIDATION_MSG.VALID_EMAIL" | translate }}
      }
      @else if (control.hasError('english')) {
        {{ "VALIDATION_MSG.EN_LETTERS" | translate }}
      }

      @else if (control.hasError('arabic')) {
        {{ "VALIDATION_MSG.AR_LETTERS" | translate }}
      }
      @else if (control.hasError('mobile')) {
        {{ "VALIDATION_MSG.VALID_MOBILE_NUMBER" | translate }}
      }
       @else if (control.hasError('emiratesId')) {
        {{ "VALIDATION_MSG.VALID_EMIRATES_ID" | translate }}
      }
      @else if (control.hasError('websiteLink')) {
        {{ "VALIDATION_MSG.VALID_WEBSITE_LINK" | translate }}
      }
       @else if (control.hasError('uaeMobile')) {
        {{ "VALIDATION_MSG.UAE_MOBILE_NUMBER" | translate }}
      }
        @else if (control.hasError('uaeLandline')) {
        {{ "VALIDATION_MSG.UAE_LANDLINE_NUMBER" | translate }}
      }
      @else if (control.hasError('numberOnly')) {
        {{ "VALIDATION_MSG.NUMBER_ONLY" | translate }}
      }
      @else if (control.hasError('numberWithDecimal')) {
        {{ "VALIDATION_MSG.NUMBER_WITH_DECIMAL" | translate }}
      }
      @else if (control.hasError('max')) {
        {{ "VALIDATION_MSG.MAX_LIMIT" | translate : { max: control.getError('max').max } }}
      }

      @else if (control.hasError('maxlength')) {
        <div>
          {{ "VALIDATION_MSG.MAXIMUM_TEXT" | translate : {maxlength:  control.getError('maxlength').requiredLength, actualLength:  control.getError('maxlength').actualLength} }}
        </div>
      }
      @else if (control.hasError('min')) {
        {{ "VALIDATION_MSG.MINIMUM_TEXT" | translate : { min: control.getError('min').min } }}
      }
      <!-- 6. Other errors dynamically (fallback) -->
      @else {
        @for (errorKey of errorKeys; track errorKey) {
          @if (control.hasError(errorKey) && errorKey !== 'maxlength') {
             <!-- {{validationMessages[errorKey] | translate}} -->
            {{ ("VALIDATION_MSG." + (errorKey | uppercase)) | translate }}
          }
        }
      }
    }
  </div>


  <!-- <div class="fields-error-container">
    @if (control.touched && control.invalid) { @for (errorKey of errorKeys;
    track errorKey) { 
      @if (control.hasError(errorKey) && errorKey !==
    'maxlength') {
      {{
        validationMessages[errorKey] ||
          (errorKey === "required"
            ? ("VALIDATION_MSG.FIELD_REQUIRED" | translate)
            : errorKey === "safeText" ? ("VALIDATION_MSG.SAFETEXT" | translate) : "Invalid value")
      }}
    } 
    @if (control.hasError('whitespace')) {
      {{ "VALIDATION_MSG.WHITESPACE" | translate }}
    }
    @if (control.hasError('maxlength') && maxlength) {
    <div>Maximum {{ maxlength }} characters allowed</div>
    } }
  }
  </div> -->
</div>
